import {
  DisabledEditabilitySettings,
  ImageItemEditabilitySettings,
  TextItemEditabilitySettings,
} from '../common/constants'
import { HOME_CLASSIC_PAGE_DESIGN } from './homeClassic'

const PlaceholderItemEdibilitySettings = {
  stylable: false,
  resizable: false,
  editable: true,
  locked: false,
  hoverable: false,
  selectable: true,
  draggable: false,
  droppable: false,
  highlightable: false,
  copyable: false,
  badgable: false,
  removable: false,
}

const SUMMARY_LABEL_STYLE = {
  color: '#000000',
  'font-weight': '600',
  'text-transform': 'uppercase',
}

const SUMMARY_PILL_STYLE = {
  color: '#0a090b',
  'font-weight': 'normal',
}

const summaryColumn = (labelText: string, placeholder: string, ids: { label: string; pill: string }) => ({
  classes: ['cover-page-v2__summary-col'],
  ...DisabledEditabilitySettings,
  components: [
    {
      tagName: 'p',
      type: 'text',
      ...TextItemEditabilitySettings,
      classes: ['cover-page-v2__summary-label'],
      style: SUMMARY_LABEL_STYLE,
      attributes: { id: ids.label },
      components: [
        {
          type: 'textnode',
          content: labelText,
        },
      ],
    },
    {
      tagName: 'placeholder',
      type: 'placeholder',
      ...PlaceholderItemEdibilitySettings,
      classes: ['cover-page-v2__summary-pill'],
      style: SUMMARY_PILL_STYLE,
      attributes: {
        'data-placeholder': placeholder,
        PLACEHOLDER_LABEL_OVERRIDE: '',
        id: ids.pill,
      },
      component: {
        compare: null,
      },
    },
  ],
})

export const COVER_PAGE_FRAMES = [
  {
    component: {
      type: 'wrapper',
      ...DisabledEditabilitySettings,
      stylable: [
        'background',
        'background-color',
        'background-image',
        'background-repeat',
        'background-attachment',
        'background-position',
        'background-size',
      ],
      components: [
        {
          tagName: 'fullscreen',
          type: 'FullScreen',
          ...DisabledEditabilitySettings,
          components: [
            {
              tagName: 'div',
              type: 'FullScreen',
              ...DisabledEditabilitySettings,
              classes: ['editor-editable-comp-fullscreen'],
              components: [
                {
                  tagName: 'custompagelayout',
                  type: 'CustomPageLayout',
                  ...DisabledEditabilitySettings,
                  components: [
                    {
                      tagName: 'defaultcoverpage',
                      type: 'DefaultCoverPage',
                      ...DisabledEditabilitySettings,
                      components: [
                        {
                          classes: ['cover-page-v2__container', 'proposal-background'],
                          ...DisabledEditabilitySettings,
                          components: [
                            {
                              classes: ['cover-page-v2__hero-image-wrapper'],
                              ...DisabledEditabilitySettings,
                              components: [
                                {
                                  type: 'image',
                                  ...ImageItemEditabilitySettings,
                                  classes: ['cover-page-v2__hero-image'],
                                  attributes: {
                                    alt: 'house-cover',
                                    src: '/house-cover.webp',
                                    loading: 'lazy',
                                  },
                                },
                              ],
                            },
                            {
                              classes: ['cover-page-v2__content-wrapper'],
                              ...DisabledEditabilitySettings,
                              components: [
                                {
                                  classes: ['cover-page-v2__content'],
                                  ...DisabledEditabilitySettings,
                                  components: [
                                    {
                                      classes: ['cover-page-v2__logo-wrapper'],
                                      ...DisabledEditabilitySettings,
                                      components: [
                                        {
                                          tagName: 'orglogoblock',
                                          type: 'OrgLogoBlock',
                                          ...DisabledEditabilitySettings,
                                        },
                                      ],
                                    },
                                    {
                                      tagName: 'p',
                                      type: 'text',
                                      ...TextItemEditabilitySettings,
                                      classes: ['cover-page-v2__headline'],
                                      style: {
                                        color: '#13171a',
                                        'font-weight': '800',
                                      },
                                      attributes: { id: 'cover-page-v2-headline' },
                                      components: [
                                        {
                                          type: 'textnode',
                                          content: 'A Smarter Energy Plan for Your Home',
                                        },
                                      ],
                                    },
                                    {
                                      tagName: 'p',
                                      type: 'text',
                                      ...TextItemEditabilitySettings,
                                      classes: ['cover-page-v2__subtitle'],
                                      style: {
                                        color: '#62686e',
                                        'font-weight': 'normal',
                                      },
                                      attributes: { id: 'cover-page-v2-subtitle' },
                                      components: [
                                        {
                                          type: 'textnode',
                                          content:
                                            'Designed to reduce your energy bills and future-proof your home with clean energy',
                                        },
                                      ],
                                    },
                                  ],
                                },
                                {
                                  classes: ['cover-page-v2__summary-card'],
                                  ...DisabledEditabilitySettings,
                                  components: [
                                {
                                  tagName: 'p',
                                  type: 'text',
                                  ...TextItemEditabilitySettings,
                                  classes: ['cover-page-v2__summary-title'],
                                  style: {
                                    color: '#000000',
                                    'font-weight': '600',
                                  },
                                  attributes: { id: 'cover-page-v2-summary-title' },
                                  components: [
                                    {
                                      type: 'textnode',
                                      content: 'Your Proposal Summary',
                                    },
                                  ],
                                },
                                {
                                  classes: ['cover-page-v2__summary-grid'],
                                  ...DisabledEditabilitySettings,
                                  components: [
                                    summaryColumn('PROJECT ADDRESS', 'project.address', {
                                      label: 'cover-page-v2-label-address',
                                      pill: 'cover-page-v2-pill-address',
                                    }),
                                    summaryColumn('CUSTOMER NAME', 'customer_name', {
                                      label: 'cover-page-v2-label-customer',
                                      pill: 'cover-page-v2-pill-customer',
                                    }),
                                    summaryColumn('SALES PERSON', 'assigned_salesperson_role.email', {
                                      label: 'cover-page-v2-label-salesperson',
                                      pill: 'cover-page-v2-pill-salesperson',
                                    }),
                                    summaryColumn('CONTACT NUMBER', 'assigned_salesperson_role.phone', {
                                      label: 'cover-page-v2-label-contact',
                                      pill: 'cover-page-v2-pill-contact',
                                    }),
                                  ],
                                },
                                {
                                  classes: ['cover-page-v2__summary-footer'],
                                  ...DisabledEditabilitySettings,
                                  components: [
                                    {
                                      tagName: 'span',
                                      type: 'text',
                                      ...TextItemEditabilitySettings,
                                      classes: ['cover-page-v2__summary-footer-label'],
                                      style: {
                                        color: '#929aa1',
                                        'font-weight': 'normal',
                                      },
                                      attributes: { id: 'cover-page-v2-footer-label' },
                                      components: [
                                        {
                                          type: 'textnode',
                                          content: 'Created ',
                                        },
                                      ],
                                    },
                                    {
                                      tagName: 'placeholder',
                                      type: 'placeholder',
                                      ...PlaceholderItemEdibilitySettings,
                                      classes: ['cover-page-v2__summary-footer-date'],
                                      style: {
                                        color: '#929aa1',
                                        'font-weight': 'normal',
                                      },
                                      attributes: {
                                        'data-placeholder': 'project.created_date',
                                        PLACEHOLDER_LABEL_OVERRIDE: '',
                                        id: 'cover-page-v2-footer-date',
                                      },
                                      component: {
                                        compare: null,
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'textnode',
                  content: '\n',
                },
              ],
            },
          ],
        },
      ],
      head: {
        type: 'head',
      },
      docEl: {
        tagName: 'html',
      },
    },
    id: 'cover-page-v2-frame-001',
  },
]

export const COVER_PAGE_ID = 'cover-page'

export const COVER_PAGE_PAGE_DESIGN = {
  frames: JSON.parse(JSON.stringify(HOME_CLASSIC_PAGE_DESIGN.frames)),
  name: 'Cover Page',
  id: COVER_PAGE_ID,
  type: 'main',
}
